export default __webpack_public_path__ + "static/media/TrackIt.ca0f9796.svg";